import { render, staticRenderFns } from "./NavigationGroup.vue?vue&type=template&id=904387a0&"
import script from "./NavigationGroup.vue?vue&type=script&lang=js&"
export * from "./NavigationGroup.vue?vue&type=script&lang=js&"
import style0 from "./NavigationGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports